<template>
 <div class="order-inquiry">
        <el-select v-model="values" filterable remote reserve-keyword placeholder="请输入订单号" :remote-method="remoteMethod">
            <el-option v-for="(item,index) in option1" :key="index" :label="item.value" :value="item.value"></el-option>
        </el-select>
 </div>
</template>

<script>
import website from '@/backend/services/website/website.js';

export default {
 name:'sky-order-inquiry',
 data() {
  return {
      values:'',
      option1:[],
  }
 },
 methods:{
     remoteMethod(query){
         if(query !== ''){
             this.getOrder(query)
         }else {
             this.option1 = [];
         }
     },
      async getOrder(query){
        let datas = await website.getOrderQuery({name:query})
          this.option1 = datas.data
    }
 },

}
</script>

<style scoped lang="scss">

</style>
